import Axios from 'axios'
import auth from '@/common/auth';
import { API_BASE } from '@/common/const';
const axios = Axios.create({
    // baseURL: 'http://127.0.0.1:7001',
    baseURL: API_BASE,
    headers: {
        'ttt': auth.getToken(),
        'Content-Type':'application/json; charset=UTF-8'
    },
    
})


axios.interceptors.request.use(config => {
    let params = config.params || {}
    params.random = Math.random()
    config.params = params
    return config
})
axios.interceptors.response.use(res => {
   
    return res
}, err => {
    if (err.response.status === 401) {
        alert('请重新登录')
        if (location.href.indexOf('admin.html') >= 0) {
            sessionStorage.setItem('backurl','admin')
        } else if (location.href.indexOf('order.html') >= 0) {
            sessionStorage.setItem('backurl','order')
        }
        location.href = '/login.html#/login'
        
    }
    return Promise.reject(err)
})

export default axios


export const login = (params) => {
    return axios.post('/login',{params})
}

export const register = (params) => {
    return axios.post('/register',{params})
}

export const submitOrder = (params) => {
    return axios.post('/submitOrder',{params})
}

export const orderDetail = (params) => {
    return axios.get('/login',{params})
}

export const myOrder = (params) => {
    return axios.get('/myOrder',{params})
}

export const updateFile = (params) => {
    return axios.post('/uplateFile',{params})
}


export const comment = (params) => {
    return axios.post('/comment',{params})
}


export const getSchedules = () => {
    return axios.get('/productschedules')
}

export const setProductSchedule = params => axios.post('/setproductschedule', params)